import { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../themes/Default/components/Form/components/Input";
import { Textarea } from "../../../../themes/Default/components/Form/components/Textarea";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { useTranslation } from "react-i18next";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../../../services/core/Select";
import { locationsManagement } from "../../../../hooks/api/LocationsManagement";
import { languagesManagement } from "../../../../hooks/api/LanguagesManagement";
import { languageProgramsManagement } from "../../../../hooks/api/LanguageProgramsManagement";
import Divider from "../../../../themes/Default/components/Divider/Divider";
import { Title } from "../../../../themes/Default/components/Title";
import DatePicker from "../../../../themes/Default/components/Form/components/DatePicker/DatePicker";
import TimePicker from "../../../../themes/Default/components/Form/components/TimePicker/TimePicker";
import { employeesManagement } from "../../../../hooks/api/EmployeesManagement";
import { Slide, toast, ToastContainer } from "react-toastify";
import { settingsCallManagement } from "../../../../hooks/api/SettingsCallManagement";

const EditTest = () => {
    const { t } = useTranslation("common");
    const { studentId, testId } = useParams();
    const formRef = useRef(null);
    const [locations, setLocations] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [languageProgram, setLanguageProgram] = useState([]);
    const [individualLessons, setIndividualLessons] = useState([]);
    const [studentFullName, setStudentFullName] = useState([]);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateTestMutation, useViewTestMutation, useViewStudentsMutation } = studentsManagement;
    const [updateTest, { isLoading: isUpdatingTest }] = useUpdateTestMutation();
    const [viewTest] = useViewTestMutation();
    const [viewStudent] = useViewStudentsMutation();

    const { useLocationListMutation } = locationsManagement;
    const { useLanguageListMutation } = languagesManagement;
    const { useProgramListMutation } = languageProgramsManagement;

    const [locationList, { isLoading }] = useLocationListMutation();
    const [languageList] = useLanguageListMutation();
    const [languageProgramList] = useProgramListMutation();

    const { useEmployeesListMutation } = employeesManagement;
    const [professorList] = useEmployeesListMutation();
    const [professors, setProfessors] = useState([]);

    const [courseType, setCourseType] = useState([]);
    const { useCourseTypeListMutation } = settingsCallManagement;
    const [courseTypeList] = useCourseTypeListMutation();

    const [status, setStatus] = useState([]);
    const { useStatusListMutation } = settingsCallManagement;
    const [statusList] = useStatusListMutation();

    const tabs = [
        { title: t("details"), onClick: () => gotoDetailsTab(studentId) },
        { title: t("students.tests"), isActive: true },
        { title: t("students.contract"), onClick: () => gotoContractsTab(studentId) },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t("groups.title"), onClick: () => gotoGroupsTab(studentId) },
        { title: t("students.certificates"), onClick: () => gotoCertificatesTab(studentId) },
        { title: t("documents"), onClick: () => gotoDocumentsTab(studentId) },
        { title: t("notes"), onClick: () => gotoNotesTab(studentId) },
    ];

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const gotoContractsTab = (studentId) => {
        navigate("/students/" + studentId + "/contracts");
    };

    const gotoCertificatesTab = (studentId) => {
        navigate("/students/" + studentId + "/certificates");
    };

    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate("/students/" + studentId + "/notes");
    };

    const gotoDocumentsTab = (studentId) => {
        navigate("/students/" + studentId + "/documents");
    };

    const gotoGroupsTab = (studentId) => {
        navigate("/students/" + studentId + "/groups");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        updateTest({ body: values, studentId, testId }).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate(`/students/${studentId}/tests`);
            }
        });
    };

    const individualLesson = () => {
        const options = [
            { id: "1", name: "1" },
            { id: "2", name: "2" },
            { id: "3", name: "3" },
            { id: "4", name: "4" },
            { id: "5", name: "5" },
            { id: "6", name: "6" },
            { id: "7", name: "7" },
            { id: "8", name: "8" },
            { id: "9", name: "9" },
            { id: "10", name: "10" },
            { id: "Ne", name: "Ne" }
        ];
    
        return prepareSelect(options);
    };

    useEffect(() => {
        viewTest({ studentId, testId }).then((result) => {
            console.log(result);
            formRef.current.setValues(result?.data);
        });
        locationList().then((result) => {
            setLocations(prepareSelect(result?.data?.records));
        });

        languageList().then((result) => {
            setLanguages(prepareSelect(result?.data?.records));
        });

        languageProgramList().then((result) => {
            setLanguageProgram(prepareSelect(result?.data?.records));
        });

        viewStudent(studentId).then((result) => {
            setStudentFullName(result?.data?.firstName + ' ' + result?.data?.lastName);
        });

        courseTypeList().then((result) => {
            setCourseType(prepareSelect(result?.data?.records));
        });

        professorList({role: 'ROLE_PROFESSOR,ROLE_DIRECTOR_OF_STUDIES'}).then((result) => {
            let options = [];
            result?.data?.records.map((professor) => {
                options.push(
                    {
                        id: professor.id,
                        name: professor.firstName + ' ' + professor.lastName
                    }
                );
            })
            setProfessors(prepareSelect(options));
        });

        setIndividualLessons(individualLesson); 

        statusList().then((result) => {
            let options = [];
            result?.data?.records.map((status) => {
                options.push({
                    id: status.id,
                    name: status.status,
                });
            });
            setStatus(prepareSelect(options));
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={'/students/' + studentId + '/tests'} />
                <Button title={t("save")} isDisabled={isUpdatingTest} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{studentFullName}</Title>
                <Breadcrumps>
                    <Link title={t("students.title")} icon="fa-user-graduate" />
                    <Link title={t("students.tests")} />
                    <Link title={t("details")} />
                    <Link title={t("students.editTests")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        backgroundKnowledge: "",
                        understanding: "",
                        expression: "",
                        vocabulary: "",
                        reading: "",
                        writtenTest: "",
                        location: null,
                        language: null,
                        languageProgram: null,
                        date: "",
                        timeFrom: "",
                        timeTo: "",
                        professor: null,
                        individualLessons: "",
                        courseType: "",
                        type: "",
                        status: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                        <Row>
                            <Field>
                                <Select 
                                    name="location" 
                                    label={t('groups.location')} 
                                    onChange={handleChange} 
                                    required={true} 
                                    options={locations} 
                                    selectedValue={values.location}
                                    error={formErrors?.location}
                                    searchInDropdown={false}
                                />
                            </Field>
                            <Field>
                                <Select
                                    name="type"
                                    label={t("students.typeName")}
                                    required={true}
                                    options={prepareSelect([
                                        { id: "Testiranje", name: t("Testiranje") },
                                        { id: "Demo čas", name: t("Demo čas") },
                                        { id: "Retestiranje", name: t("Retestiranje") },
                                    ])}
                                    onChange={(e) => {
                                        handleChange(e);
                                    }}
                                    selectedValue={values.type}
                                    error={formErrors?.type}
                                    searchVisible={false}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Select 
                                    name="professor" 
                                    label={t('groups.professor')} 
                                    onChange={handleChange} 
                                    required={true} 
                                    options={professors} 
                                    selectedValue={values.professor} 
                                    error={formErrors?.professor}
                                    searchInDropdown={false}
                                />
                            </Field>
                            <Field>
                                <DatePicker
                                    name="date"
                                    label={t("calendar.date")}
                                    required={true}
                                    value={values.date}
                                    onChange={handleChange}
                                    error={formErrors?.date}
                                    disablePast={true}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <TimePicker
                                    name="timeFrom"
                                    label={t("calendar.timeFrom")}
                                    required={true}
                                    value={values.timeFrom}
                                    onChange={handleChange}
                                    error={formErrors?.timeFrom}
                                />
                            </Field>
                            <Field>
                                <TimePicker
                                    name="timeTo"
                                    label={t("calendar.timeTo")}
                                    required={true}
                                    value={values.timeTo}
                                    onChange={handleChange}
                                    error={formErrors?.timeTo}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Select
                                    name="courseType"
                                    label={t("students.contractGroupType")}
                                    required={true}
                                    options={courseType}
                                    onChange={handleChange}
                                    selectedValue={values.courseType}
                                    error={formErrors?.courseType}
                                    searchInDropdown={false}
                                />
                            </Field>
                            <Field>
                                <Select 
                                    name="language" 
                                    label={t('groups.language')} 
                                    onChange={handleChange} 
                                    required={true} 
                                    options={languages} 
                                    selectedValue={values.language} 
                                    error={formErrors?.language}
                                    searchInDropdown={false}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    required={true} 
                                    name="backgroundKnowledge"
                                    label={t("test.backgroundKnowledge")}
                                    rows={5}
                                    value={values.backgroundKnowledge}
                                    onChange={handleChange}
                                    error={formErrors?.backgroundKnowledge}
                                />
                            </Field>
                        </Row>
                        <Divider title={"Rezultati testa"} />
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="understanding"
                                    label={t("test.understanding")}
                                    rows={5}
                                    value={values.understanding}
                                    onChange={handleChange}
                                    error={formErrors?.understanding}
                                />
                            </Field>
                            
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="expression"
                                    label={t("test.expression")}
                                    rows={5}
                                    value={values.expression}
                                    onChange={handleChange}
                                    error={formErrors?.expression}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="vocabulary"
                                    label={t("test.vocabulary")}
                                    rows={5}
                                    value={values.vocabulary}
                                    onChange={handleChange}
                                    error={formErrors?.vocabulary}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="reading"
                                    label={t("test.reading")}
                                    rows={5}
                                    value={values.reading}
                                    onChange={handleChange}
                                    error={formErrors?.reading}
                                />
                            </Field>
                        </Row> 
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="writtenTest"
                                    label={t("test.writtenTest")}
                                    rows={5}
                                    value={values.writtenTest}
                                    onChange={handleChange}
                                    error={formErrors?.writtenTest}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="note"
                                    label={t("test.note")}
                                    rows={5}
                                    value={values.note}
                                    onChange={handleChange}
                                    error={formErrors?.note}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Select
                                    name="status"
                                    label={t("status")}
                                    options={status}
                                    onChange={handleChange}
                                    selectedValue={values.status}
                                    error={formErrors?.status}
                                    searchInDropdown={false}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Select 
                                    name="individualLessons" 
                                    label={t('test.individualLesson')}
                                    onChange={handleChange} 
                                    options={individualLessons} 
                                    selectedValue={values.individualLessons}
                                />
                            </Field>
                            <Field>
                                <Select 
                                    name="languageProgram" 
                                    label={t('test.languageProgram')} 
                                    onChange={handleChange} 
                                    options={languageProgram} 
                                    selectedValue={values.languageProgram} 
                                    error={formErrors?.program}
                                />
                            </Field>
                        </Row>
                    </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditTest;
